import { PropsWithChildren } from 'react'
import styles from './InfoCard.module.scss'

export const InfoCard = ({ children }: PropsWithChildren) => {
    return <section className={styles.container}>{children}</section>
}
